import { createContext, useEffect, useRef, useState } from "react";
import { getAllSavedSongs, getAudios } from "../lib/utils/apiCalls";

export const VideoContext = createContext();

export const VideoContextProvider = ({ children }) => {
    const videoRef = useRef(null);

    const [videoFile, setVideoFile] = useState({});
    const [originalAudioUrl, setOriginalAudioUrl] = useState('');

    const [musicList, setMusicList] = useState([]);
    const [savedMusicList, setSavedMusicList] = useState([]);
    const [trackID, setTrackID] = useState('');
    const [selectedAudio, setSelectedAudio] = useState({});
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [hasVoiceOver, setHasVoiceOver] = useState(false);

    const [loading, setLoading] = useState(false);

    const handleSavedAudioRequest = async () => {
        try {
            const response = await getAllSavedSongs();
            setSavedMusicList(response);
        }
        catch (err) {
            console.log('Error occurred:', err);
        }
    }

    useEffect(() => {
        const handleAudioRequest = async () => {
            try {
                const response = await getAudios();
                setMusicList(response);
            }
            catch (err) {
                console.log('Error occurred:', err);
            }
        }

        handleAudioRequest();
        handleSavedAudioRequest();
    }, []);

    const contextValue = {
        videoRef,
        musicList, savedMusicList,
        trackID,
        setTrackID,

        selectedAudio, setSelectedAudio,
        isPlaying, setIsPlaying,
        isMuted, setIsMuted,
        videoFile, setVideoFile,
        originalAudioUrl, setOriginalAudioUrl,

        loading, setLoading,
        hasVoiceOver, setHasVoiceOver, handleSavedAudioRequest
    };

    return (
        <VideoContext.Provider value={ contextValue }>
            { children }
        </VideoContext.Provider>
    );
}
